import { useEffect, useState } from 'react';
import MESSAGE_TYPES from '../constants/MESSAGE_TYPES';
import Messager from '../lib/messager';
import type { IStateController } from '../lib/widget/state/state.interface';
import { useInjection } from 'inversify-react';
import { STATE_MODULE_IDS } from '../lib/widget/state/state.types';

const INITIAL_STATE = {
  values: {
    tickets: 1,
    fio: '',
    email: '',
    phone: '',
    comment: '',
    accept: false,
  },
  touched: false,
  isLoading: false,
  showSuccessModal: false,
};

let errors: object = {};

const useOrderForm = () => {
  const stateController: IStateController = useInjection(STATE_MODULE_IDS.STATE_CONTROLLER);
  const { Widget } = window;
  const [state, setState] = useState(INITIAL_STATE);
  const { dates } = Widget.settings;
  const hasDatesWithTickets = dates
    ? dates.filter((date) => date && date.has_tickets).length > 0
    : false;
  useEffect(() => {
    window.addEventListener('message', handleReceiveMessage, false);
    stateController.addListener(stateController.events.RELOAD_TICKETS, hideSuccessModal);

    return () => {
      window.removeEventListener('message', handleReceiveMessage, false);
      stateController.removeListener(stateController.events.RELOAD_TICKETS, hideSuccessModal);
    };
  }, []);

  const handleReceiveMessage = (event) => {
    const message = event.message ? 'message' : 'data';

    if (event[message].type === MESSAGE_TYPES.SHOW_ORDER_SUCCESS) {
      setState({
        ...INITIAL_STATE,
        showSuccessModal: true,
      });
    }
  };

  const updateForm = (name, value) => {
    const { listenOrderForm } = Widget.settings;

    setState((prevState) => {
      const newState = {
        ...prevState,
        values: {
          ...state.values,
          [name]: value,
        },
      };

      if (listenOrderForm) {
        Messager.send({
          type: MESSAGE_TYPES.ORDER_FORM_CHANGED,
          values: newState.values,
        });
      }

      return newState;
    });
  };

  const handleBlur = (name, value) => {
    Messager.send({
      type: MESSAGE_TYPES.ORDER_FORM_INPUT_BLURED,
      values: {
        name,
        value,
      },
    });
  };

  const submitForm = (event) => {
    event.preventDefault();
    const { values } = state;

    const invalid = Object.keys(errors).some((key) => errors[key]);

    let isLoading = false;

    if (!invalid) {
      Messager.send({
        type: MESSAGE_TYPES.SUBMIT_ORDER_FORM,
        values: {
          ...values,
          meta: {
            ...Widget.metaController.meta,
            selectedEvent: Widget.metaController.selectedEvent,
          },
        },
      });
      isLoading = true;
    }

    setState((prevState) => ({
      ...prevState,
      isLoading,
      touched: true,
    }));
  };

  const hideSuccessModal = () => {
    setState((prevState) => ({
      ...prevState,
      showSuccessModal: false,
    }));
  };

  const setError = (name, error) => {
    errors = {
      ...errors,
      [name]: error,
    };
  };

  return {
    dates,
    hasDatesWithTickets,
    state,
    submitForm,
    setError,
    updateForm,
    handleBlur,
    hideSuccessModal,
  };
};

export default useOrderForm;
